import React from "react";
import KuikaButton from "../../../../ui-kit/kuika-button/kuika-button";
import KuikaPopover from "../../../../ui-kit/kuika-popover/kuika-popover";
import { ShowcaseFrame } from "../_layout/showcase-frame";
import { SpecRow } from "../_layout/spec-row";
import { VariantGrid } from "../_layout/variant-grid";

type PopoverPosition = "top" | "right" | "bottom" | "left";

const POSITIONS: PopoverPosition[] = ["top", "right", "bottom", "left"];

interface ISurfaceProps {
  position?: PopoverPosition;
  title?: string;
  hideClose?: boolean;
}

const Surface: React.FC<ISurfaceProps> = ({ position = "bottom", title, hideClose }) => (
  <KuikaPopover
    position={position}
    title={title}
    hideCloseIcon={hideClose}
    content={
      <div style={{ padding: 16, maxWidth: 240, fontSize: 13, color: "var(--lab-ink-muted)" }}>
        Anchored content surface that can hold rich UI — forms, lists or summaries.
      </div>
    }
  >
    <KuikaButton type="secondary" size="sm">
      {position}
    </KuikaButton>
  </KuikaPopover>
);

export const PopoverStory: React.FC = (): JSX.Element => {
  return (
    <ShowcaseFrame
      title="Popover"
      componentName="KuikaPopover"
      sourcePath="ui-kit/kuika-popover"
      description="Anchored floating surface. Four positions, optional title bar with close icon, configurable click-outside behaviour."
    >
      <VariantGrid
        label="position"
        cols={POSITIONS}
        cellMinWidth={160}
        render={(position: string): React.ReactNode => <Surface position={position as PopoverPosition} title="Note" />}
      />
      <SpecRow label="Without title bar" caption="title omitted">
        <Surface position="bottom" />
      </SpecRow>
      <SpecRow label="Without close icon" caption="hideCloseIcon=true">
        <Surface position="bottom" title="Quick info" hideClose />
      </SpecRow>
    </ShowcaseFrame>
  );
};
